{
  "journal": {
    "title": "Журнал событий",
    "label": "Журнал",
    "auto_update": "Автоматическое обновление событий",
    "error": {
      "generic": "Ошибка при получении новых событий с сервера"
    },
    "filter": {
      "application": {
        "any": "Любое"
      },
      "event_type": {
        "any": "Любой"
      },
      "instance_id": {
        "any": "Любой"
      }
    }
  }
}
